import React from 'react';
import { Grid, Paper, Typography, Box, useTheme, useMediaQuery, Chip, Stack } from '@mui/material';
import UserActivityWidget from '../components/dashboard/UserActivityWidget';
import CodeOwnerWidget from '../components/dashboard/CodeOwnerWidget';
import Layout from '../components/layout/Layout';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const Dashboard = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Layout>
            <Box sx={{ 
                width: '100%',
                maxWidth: '100%',
                overflowX: 'hidden',
                p: { xs: 1, sm: 2.5 },
                boxSizing: 'border-box'
            }}>
                {/* Header Banner */}
                <Box sx={{ 
                    mb: 3, 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    justifyContent: 'space-between',
                    gap: 1.5 
                }}>
                    <Box>
                        <Typography 
                            variant={isMobile ? "h5" : "h4"} 
                            sx={{ fontWeight: 800, letterSpacing: '-0.02em', color: '#0F172A' }}
                        >
                            Operations Dashboard
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#64748B', mt: 0.5 }}>
                            Real-time monitoring of user queries, code engagements, and registered code owners.
                        </Typography>
                    </Box>

                    <Stack direction="row" spacing={1} sx={{ mt: { xs: 1, sm: 0 } }}>
                        <Chip 
                            icon={<TrendingUpIcon style={{ fontSize: 16 }} />}
                            label="Live Analytics" 
                            size="small" 
                            color="primary" 
                            sx={{ fontWeight: 700, borderRadius: 2 }} 
                        />
                    </Stack>
                </Box>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Paper 
                            elevation={0}
                            sx={{ 
                                width: '100%',
                                p: { xs: 1.5, sm: 2.5 },
                                borderRadius: 3,
                                border: '1px solid #E2E8F0',
                                backgroundColor: '#FFFFFF',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.03)'
                            }}
                        >
                            <UserActivityWidget />
                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper 
                            elevation={0}
                            sx={{ 
                                p: { xs: 1.5, sm: 2.5 },
                                borderRadius: 3,
                                border: '1px solid #E2E8F0',
                                backgroundColor: '#FFFFFF',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.03)'
                            }}
                        >
                            <CodeOwnerWidget />
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </Layout>
    );
};

export default Dashboard;